import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';

import { Navigation } from 'common';

import ApplicantsFunnel from './charts/applicantsFunnel/applicantsFunnel';
import ApplicantsShortlisted from './charts/applicantsShortlisted/applicantsShortlisted';
import DayWiseApplication from './charts/dayWiseApplication/dayWiseApplication';
import ExperienceDistribution from './charts/experienceDistribution/experienceDistribution';
import StatsCards from './statsCards/statsCards';
import SummaryCards from './summaryCards/summaryCards';
import TopSkills from './charts/topSkills/topSkills';
import TopBar from './topbar';
import Skills from './charts/skills/skills';
import JobRoleDistribution from './charts/jobRoleDistribution/jobRoleDistribution';

const useStyles = makeStyles(() => ({
  container: {
    padding: 24,
    background: '#fbfbfb',
    position: 'relative',
    minHeight: 'calc(100vh - 54px)',
    alignContent: 'flex-start',
  },
  topBar: {
    height: 52,
    width: '100%',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    margin: '52px 0 0',
    background: '#fbfbfb',
  },
}));

const ApplicantsDashboard = () => {
  const classes = useStyles();
  const params = useParams();
  const history = useHistory();
  const jobId = params.id || '';

  if (!jobId) {
    history.goBack();
  }

  return (
    <>
      <Navigation />
      <TopBar />
      <Grid container classes={{ root: classes.container }}>
        <Grid item xs={6}>
          <SummaryCards jobId={jobId} />
        </Grid>
        <Grid item xs={6}>
          <StatsCards jobId={jobId} />
        </Grid>
        <Grid item xs={6}>
          <ApplicantsShortlisted jobId={jobId} />
        </Grid>
        <Grid item xs={6}>
          <ApplicantsFunnel jobId={jobId} />
        </Grid>
        <Grid item xs={4}>
          <TopSkills jobId={jobId} />
        </Grid>
        <Grid item xs={4}>
          <DayWiseApplication jobId={jobId} />
        </Grid>
        <Grid item xs={4}>
          <ExperienceDistribution jobId={jobId} />
        </Grid>
        <Grid item xs={12}>
          <JobRoleDistribution jobId={jobId} />
        </Grid>
        <Grid item xs={12}>
          <Skills jobId={jobId} />
        </Grid>
      </Grid>
    </>
  );
};

export default ApplicantsDashboard;
